import { Button, CircularProgress, InputBase, styled, Typography } from "@mui/material";

import Breadcrumbs from "@mui/material/Breadcrumbs";

import NavigateBeforetIcon from "@mui/icons-material/NavigateBefore";
import shortid from "shortid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ChangeEvent, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiAddAccountingType, apiGetAccountingTypes, apiUpdateAccountingType } from "api/accountingTypeApi";
import { appCloseModal } from "store/actions/appAction";
import Select from "react-select";
import { apiSetAlert } from "api/appApi";
import { CheckBoxInput } from "components/Input";

const Container = styled("div")({
  padding: "24px",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  gap: 36
});
const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    minHeight: 30,
    height: 32,
    borderColor: "#c5c5c5",
    borderRadius: 5,
    marginTop: 2,
    marginBottom: 2,
    fontSize: 12
  })
};
const BreadcrumbsContainer = styled("div")({
  display: "flex",
  // direction: 'ltr',
  justifyContent: "start"
});
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  borderColor: theme.palette.disabled.main,
  borderRadius: theme.shape.borderRadius,
  borderWidth: "2px",
  borderStyle: "solid",
  paddingRight: "10px",
  maxWidth: "300px",
  height: "40px"
}));
const InputContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "70px"
}));
const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  "& span": {
    fontSize: "13px"
  },
  marginRight: 0
}));

type InputProps = {
  label: string;
  name: string;
  value: any;
  onChange: (event: ChangeEvent<HTMLInputElement>, value?: string) => void;
};

const TextInput = ({ label, name, value, onChange }: InputProps) => {
  return (
    <InputContainer>
      <Typography variant="body2" key={shortid.generate()} color="text.primary">
        {label}
      </Typography>
      <StyledInputBase name={name} value={value} onChange={onChange} />
    </InputContainer>
  );
};
const RadioInput = ({ label, name, value, onChange }: InputProps) => {
  return (
    <InputContainer>
      <Typography variant="body2" key={shortid.generate()} color="text.primary">
        {label}
      </Typography>
      <RadioGroup
        sx={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="person"
        // @ts-ignore
        onChange={onChange}
        name={name}
        value={value}
      >
        <StyledFormControlLabel value="شخص" control={<Radio />} label="شخص" />
        <StyledFormControlLabel value="کالا" control={<Radio />} label="کالا" />
        <StyledFormControlLabel value="حساب" control={<Radio />} label="حساب" />
        <StyledFormControlLabel value="none" control={<Radio />} label="هیچکدام" />
      </RadioGroup>
    </InputContainer>
  );
};

const AddAccountTypeModal = (props: any) => {
  const { breadCrumb, id, parentCode, initialAccountingData } = props as {
    breadCrumb: string[];
    id: number;
    parentCode?: string
    initialAccountingData: { isCurrency: boolean, accountingCode: string; title: string; detail: string; targetTable: string; code: string };
  };
  const initialState = {
    accountingCode: initialAccountingData?.accountingCode || "",
    parentId: id,
    isCurrency:initialAccountingData?.isCurrency|| false,
    parentCode: parentCode || "",
    title: initialAccountingData?.title || "",
    detail: initialAccountingData?.detail || "",
    targetTable: initialAccountingData?.targetTable || "",
    code: (parentCode && parentCode != "" && initialAccountingData?.code) ? initialAccountingData?.code?.replace(parentCode, "") : initialAccountingData?.code || ""
  }

  const options = [
    {
      value: "product",
      label: "محصول"
    },
    {
      value: "person",
      label: "شخص"
    },
    {
      value: "shareholder",
      label: "سهامدار"
    },
    {
      value: "financial",
      label: "مالی"
    },
    {
      value: "costCenter",
      label: "مرکز هزینه"
    }
  ];
  const [accountingData, setAccountingData] = useState(initialState);
  const [loading, setLoading] = useState(false);

  const { accountingCode, parentId, title, detail, code, isCurrency } = accountingData;

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setAccountingData({ ...accountingData, [name]: value });
  };
  const onOptionChangeHandler = (event: any) => {
    let target = "";
    // switch (event.value) {
    //   case "محصول":
    //     target = "product";
    //     break;
    //   case "سهامدار":
    //     target = "shareholder";
    //     break;
    //   case "مالی":
    //     target = "financial";
    //     break;
    //   case "شخص":
    //     target = "person";
    //     break;
    //   default:
    //     target = "";
    //     break;
    // }
    target = event.value;
    setAccountingData({ ...accountingData, targetTable: target });
  };

  const onCodeChangeHandle = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newValue = e.target.value.replace(/[^0-9]/g, ''); // This removes all non-numeric characters
    setAccountingData({ ...accountingData, [name]: newValue });
  }

  const dispatch = useDispatch();
  //@ts-ignore
  const { token } = useSelector((state) => state).businessReducer.business;

  const callBack = () => {
    setLoading(false)
    // @ts-ignore
    dispatch(apiGetAccountingTypes(token));
    dispatch(appCloseModal());
  };

  const breadcrumbs = breadCrumb.map((item) => (
    <Typography variant="body2" key={shortid.generate()} color="text.primary">
      {item}
    </Typography>
  ));
  // @ts-ignore
  return (
    <Container>
      <div className="flex flex-col gap-2">
        <Typography>حساب مرجع</Typography>
        <BreadcrumbsContainer>
          <Breadcrumbs separator={<NavigateBeforetIcon fontSize="small" />} aria-label="breadcrumb">
            {breadcrumbs}
          </Breadcrumbs>
        </BreadcrumbsContainer>
      </div>
      {/*<TextInput value={accountingCode} label='کد حسابداری' name='accountingCode' onChange={handleChangeInput} />*/}
      {/*<RadioInput value={detail} name='detail' onChange={handleChangeInput} label='تفصیل' />*/}
      <TextInput value={title} name="title" onChange={handleChangeInput} label="عنوان" />
      <Typography>{`کد مرجع: ${parentCode || ""}`}</Typography>
      <TextInput value={code} name="code" onChange={onCodeChangeHandle} label="کد" />
      <CheckBoxInput
      onChange={(value:boolean)=>{
        setAccountingData({ ...accountingData, ["isCurrency"]: value });

      }}
        input={
          {

            disabled: false,
            defaultValue: isCurrency,
            name: "isCurrency",
            label: "حساب ارزی",
          }
        }
      />
      <span>انتخاب تفضیل:</span>
      <Select
        styles={customStyles}
        isRtl={true}
        isMulti={false}
        placeholder={"انتخاب تفضیل"}
        options={options}
        value={options.find(o => o.value === accountingData.targetTable) ?? { value: "", label: "" }}
        onChange={(value) => {
          onOptionChangeHandler(value);
        }}
      />
      <Button
        onClick={() => {
          let formated = accountingData;
          if (formated.detail === "none") {
            // @ts-ignore
            formated = { ...accountingData, detail: null, code: parentCode ? parentCode.concat(code) : code };
          } else {
            formated = { ...accountingData, code: parentCode ? parentCode.concat(code) : code };
          }
          if (formated.code !== parentCode && formated.title !== "") {
            setLoading(true)
            if (initialAccountingData)
              // @ts-ignore
              return dispatch(apiUpdateAccountingType({ ...formated, id: formated.parentId }, token, callBack));

            // @ts-ignore
            return dispatch(apiAddAccountingType(formated, token, callBack));
          } else {
            // @ts-ignore
            dispatch(apiSetAlert("فیلد های عنوان و کد اجباری می باشد لطفا تکمیل نمایین.", "error", true))
          }
        }}
        sx={{ width: "80px" }}
        disableRipple
        disabled={loading}
        variant="contained"
      >
        {
          loading ?
            <CircularProgress color="primary" />
            :
            'ثبت'
        }
      </Button>
    </Container >
  );
};

export default AddAccountTypeModal;
